import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type BackgroundMode = 'starfield' | 'image' | 'off';

interface BackgroundState {
  mode: BackgroundMode;
  customImage: string | null;
  setMode: (mode: BackgroundMode) => void;
  cycleMode: () => void;
  setCustomImage: (url: string | null) => void;
}

const MODE_ORDER: BackgroundMode[] = ['starfield', 'image', 'off'];

export const useBackgroundStore = create<BackgroundState>()(
  persist(
    (set, get) => ({
      // 默认关闭：安静底色利于阅读；用户可自行开启静态星空/自定义背景
      mode: 'off',
      customImage: null,
      setMode: (mode) => set({ mode }),
      cycleMode: () => {
        const current = get().mode;
        const idx = MODE_ORDER.indexOf(current);
        const next = MODE_ORDER[(idx + 1) % MODE_ORDER.length];
        set({ mode: next });
      },
      setCustomImage: (url) => set({ customImage: url }),
    }),
    {
      name: 'panda-oj-bg',
      version: 1,
      migrate: (persisted: any) => {
        // 兼容旧的 enabled: boolean 格式
        if (typeof persisted?.enabled === 'boolean') {
          return {
            mode: persisted.enabled ? 'starfield' : 'off',
            customImage: null,
          };
        }
        return persisted;
      },
    },
  ),
);
